import { AnimalsTask } from 'aos-services/src/services/tasks/types/task/AnimalsTask'
import { DeIcingTask } from 'aos-services/src/services/tasks/types/task/DeIcingTask'
import { InspectionTask } from 'aos-services/src/services/tasks/types/task/InspectionTask'
import { MaintenanceTask } from 'aos-services/src/services/tasks/types/task/MaintenanceTask'
import { RefuellingTask } from 'aos-services/src/services/tasks/types/task/RefuellingTask'
import { RescueServiceTask } from 'aos-services/src/services/tasks/types/task/RescueServiceTask'
import { SimpleTask } from 'aos-services/src/services/tasks/types/task/SimpleTask'
import { Task } from 'aos-services/src/services/tasks/types/task/Task'
import { TaskTemplate } from 'aos-services/src/services/tasks/types/task/TaskTemplate'
import { TerminalTask } from 'aos-services/src/services/tasks/types/task/TerminalTask'
import { TaskType } from 'aos-services/src/services/tasks/types/TaskType'
import { useTranslation } from 'react-i18next'

import type { PropsListEntry } from '../PropsListEntry'
import { animalsTaskPropertyList } from './AnimalsTaskPropertyList'
import { deicingTaskPropertyList } from './DeicingTaskPropertyList'
import { inspectionTaskPropertyList } from './InspectionTaskPropertyList'
import { maintenanceTaskPropertyList } from './MaintenanceTaskPropertyList'
import { refuellingTaskPropertyList } from './RefuellingTaskPropertyList'
import { rescueServiceTaskPropertyList } from './RescueServiceTaskPropertyList'
import { simpleTaskPropertyList } from './SimpleTaskPropertyList'
import { terminalTaskPropertyList } from './TerminalTaskPropertyList'

export const DetailedTaskPropertyList = (t: Task | TaskTemplate): PropsListEntry[] => {
    const { t: translate } = useTranslation()

    switch (t.type) {
        case TaskType.Simple:
            return simpleTaskPropertyList(translate)(t as SimpleTask | TaskTemplate<SimpleTask>)
        case TaskType.AnimalPrevention:
            return animalsTaskPropertyList(translate)(t as AnimalsTask | TaskTemplate<AnimalsTask>)
        case TaskType.DeIcing:
            return deicingTaskPropertyList(translate)(t as DeIcingTask | TaskTemplate<DeIcingTask>)
        case TaskType.Maintenance:
            return maintenanceTaskPropertyList(t as MaintenanceTask | TaskTemplate<MaintenanceTask>)
        case TaskType.RescueService:
            return rescueServiceTaskPropertyList(
                t as RescueServiceTask | TaskTemplate<RescueServiceTask>,
            )
        case TaskType.Inspection:
            return inspectionTaskPropertyList(translate)(
                t as InspectionTask | TaskTemplate<InspectionTask>,
            )
        case TaskType.Refuelling:
            return refuellingTaskPropertyList(translate)(
                t as RefuellingTask | TaskTemplate<RefuellingTask>,
            )
        case TaskType.Terminal:
            return terminalTaskPropertyList(translate)(
                t as TerminalTask | TaskTemplate<TerminalTask>,
            )
        default:
            return []
    }
}
